<template>
    <div class="w-100 d-flex flex-column justify-content-between">
        <HeaderBar/>
        <div class="px-1 ">
            <div class="d-flex flex-column  mt-4 ">
                <div class="title d-flex justify-content-center align-items-center mt-2">
                    Crear Finca
                </div> 
            </div>
            <div>
            <validation-observer ref="GanForm">
                <b-form class="auth-register-form " @submit.prevent="">
                    <b-form-group label="Nombre" label-for="name" class="name">
                        <validation-provider #default="{ errors }" name="Nombre" rules="required">
                            <b-form-input id="name" v-model="farm.name"
                                :state="errors.length > 0 ? false : null" name="name" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Área Total en Ha" label-for="total" >
                        <validation-provider #default="{ errors }" name="Area Total" rules="required">
                            <b-form-input id="total" v-model="farm.total_ha"
                                :state="errors.length > 0 ? false : null" name="veterinarian" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <div class="d-flex">
                        <b-form-group label="Area de Pastos" label-for="pastureArea" class="pt-0 mt-0" >
                        <validation-provider #default="{ errors }" name="Area de pastos" rules="required">
                            <b-form-input id="pastureArea" v-model="farm.pasture_ha"
                                :state="errors.length > 0 ? false : null" name="pastureArea" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        </b-form-group>
                        <b-form-group label="# de Apartos" label-for="device" class="pt-0 mt-0">
                            <validation-provider #default="{ errors }" name="Apartos" rules="required">
                                <b-form-input id="device" v-model="farm.aparts_ha"
                                    :state="errors.length > 0 ? false : null" name="device" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        
                    </div>
                    <div class="d-flex">
                        <b-form-group label="Area Bosque" label-for="forest" class="pt-0 mt-0">
                            <validation-provider #default="{ errors }" name="Area de bosque" rules="required">
                                <b-form-input id="forest" v-model="farm.forest_ha"
                                    :state="errors.length > 0 ? false : null" name="veterinarian" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group> 
                        <b-form-group label="Mes de destete" label-for="forest" class="pt-0 mt-0">
                            <validation-provider #default="{ errors }" name="Mes de destete" rules="required">
                                <b-form-input id="forest" v-model="farm.destete"
                                    :state="errors.length > 0 ? false : null" name="veterinarian" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group> 
                    </div>
                    <b-form-group label="Código de establecimiento" label-for="CVO">
                        <validation-provider #default="{ errors }" name="Código de establecimiento" :rules="{required:true, regex:'^[1-7]{1}[0-9]{2}-[0-9]{6}$'}">
                            <b-form-input id="CVO" v-model="farm.cvo"  
                                v-mask="'###-######'"
                                :state="errors.length > 0 ? false : null" name="veterinarian" placeholder="___-______"/>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    
                   
                    <b-form-group label="Sistema Productivo" label-for="productSystem" class=" w-100 mr-1">
                        <b-form-select id="productSystem" v-model="farm.system_id" :options="productSystemOptions" :value="productSystemOptions.value" label="text" />
                    </b-form-group>
                    <b-form-group label="Provincia" label-for="batch" class="w-100">
                        <b-form-select id="batch" v-model="farm.province_id" :options="provincesOptions" :value="provincesOptions.value" label="text" />
                    </b-form-group>
                  
                    <b-form-group label="Cantón" label-for="canton ">

                        <b-form-select id="canton" v-model="farm.canton_id" :options="cantonOptions"  :value="cantonOptions.value"  label="text" />
                    </b-form-group>
                    <b-form-group label="Distrito" label-for="district">

                        <b-form-select id="district" v-model="farm.district_id" :options="districtOptions" :value="districtOptions.value" label="text" />
                    </b-form-group>
                    <div class="d-flex justify-content-center pb-5 ">
                        <b-button  @click="modalShow = !modalShow"
                            class="bg-primary dataButton  d-flex align-items-center justify-content-center w-75 ">
                            <div class="ml-3"> Agregar ubicación </div>
                        </b-button >
                    </div>
                    <div class="d-flex justify-content-center pb-5 ">
                        <b-button type="submit" v-on:click="insertFarm"
                            class="bg-primary dataButton  d-flex align-items-center justify-content-center w-75 ">
                            <div class="ml-3"> Incluir Finca </div>
                            <div class="ml-3" style="color:#D7B92C">
                                <feather-icon icon="PlusIcon" size="20" />
                            </div>
                        </b-button>
                    </div>
                    <b-modal size="sm" centered v-model="modalShow" hide-footer hide-header style="height: 300px"  @shown="modalShownMap">
                        <div> <h2 style="text-align: center;">Seleccione ubicación de finca</h2> </div>
                        <div class="d-flex flex-column align-items-center justify-content-center">  
                            <template>
                                <l-map
                                    ref="mymap"
                                    v-if="showMap"
                                    :zoom="zoom"
                                    :center="center"
                                    :options="mapOptions"
                                    style="height: 300px;"
                                >
                                    <l-tile-layer :url="url" :attribution="attribution"/>
                                    <l-marker 
                                        :lat-lng="center" 
                                        :draggable="true"
                                        :lat-lng.sync="positionxy"
                                    ></l-marker>
                                </l-map>
                            </template>
                            <b-button @click="modalShow = false"  class=" mt-2 mb-2">Confirmar</b-button>
                        </div>
                    </b-modal>
                </b-form>
            </validation-observer>
            </div>
        </div>
        <ControlMenu />
    </div>
</template>



<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from 'vue-select'
import axios from 'axios'
import "vue-select/dist/vue-select.css";
import { mask } from 'vue-the-mask';

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormTextarea,BFormSelect, BFormGroup, BFormInput, BForm, BImg, BButton, BFormCheckbox } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

import { LMap, LTileLayer, LMarker} from 'vue2-leaflet';
import { Icon, latLng } from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
let apiURL='https://927d1d30.us-south.apigw.appdomain.cloud/ganapp/api/';
export default {
    directives: {mask},
    components: {
        ControlMenu,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        HeaderBar,
        BFormInput,
        BForm,
        required,
        vSelect,
        BImg,
        BButton,
        BFormCheckbox,
        BFormTextarea,
        LMap,
        LTileLayer,
        LMarker,
        BFormSelect,
    },
    data() {
        return {
            modalShow: false,
            date: null,
            dateDefault: null,
            timePicker: null,
            datetime: null,
            multiDate: null,
            rangeDate: null,    
            humanDate: null,
            disableDate: null,
            inlineDate: null,
            veterinarian: '',
            femaleAnimal: null,
            totalLitter: '',
            productSystemOptions:[],
            cvoOptions:[],
            /**MAP */
            zoom: 15,
            center: [12.1493775, -86.2463238],
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            currentZoom: 1,
            currentCenter: [12.1493775, -86.2463238],
            showParagraph: false,
            mapOptions: {
                zoomSnap: 0.5
            },
            showMap: true,
            /**End MAP */
            batch: '',
            canton: '',
            cantonOptions:[],
            animal: '',
            ageOptions: [],
            batchOptions: [],
            provincesOptions:[],
            animalOptions: [],
            districtOptions:[],
            positionxy:{},
            farm:{
                name: '',
                total_ha:'',
                forest_ha:'',
                aparts_ha:'',
                pasture_ha:'',
                cvo:'',
                system_id:'',
                province_id:'',
                canton_id:'',
                district_id:'',
                lat:null,
                lon:null,
                destete:7,
                user_id:localStorage.getItem('userID'),
            }
        }
    },
    methods: {
        async fetchProductSystem(config){
            fetch(this.$apiUrl+"list/systems", config)
            .then(response => response.json())
            .then(result => {
                this.productSystemOptions = result.systems.map(item => {return {value:item.id,text:item.name}})
            })
        },

        async fetchProvinces(config){
          
          fetch(this.$apiUrl+"list/provinces", config)
          .then(response => response.json())
          .then(result => {
              console.log(result.provinces);
              this.provincesOptions = result.provinces.map(item => {return {value:item.id,text:item.name}})
          })
        },

        async fetchCantons(config){
          
            fetch(this.$apiUrl+"list/cantons", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.cantons);
                this.cantonOptions = result.cantons.map(item => {return {value:item.id,text:item.name}})
            })
        },
        
        async fetchDistricts(config){
            fetch(this.$apiUrl+"list/districts", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.districts);
                this.districtOptions = result.districts.map(item => {return {value:item.id,text:item.name}})
            })
        },

        insertFarm(){
            this.$refs.GanForm.validate().then(success => {
                if(success){
                    //let aparts = parseFloat(this.farm.aparts_ha);
                    let pasture = parseFloat(this.farm.pasture_ha);
                    let forest = parseFloat(this.farm.forest_ha);
                    if(parseFloat(forest+pasture)>parseFloat(this.farm.total_ha)){
                        this.$swal({
                                title: 'Registro de finca',
                                text: 'El área total no debe ser menor al area de pastos y bosques.',
                                type: 'warning',
                                icon:'warning',
                                showCancelButton: false,
                                confirmButtonColor:'#5E8F23',
                                showCloseButton: true,
                                showLoaderOnConfirm: false  
                            });
                    }else{
                        let self= this;
                        const token = localStorage.getItem("accessToken");
                        console.log(this.positionxy);
                        this.farm.lat=this.positionxy.lat;
                        this.farm.lon=this.positionxy.lng;
                        console.log(this.farm);
                        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                        this.$http.post("add/farms", this.farm,config).then(() => {
                            this.farm={
                                name: '',
                                total_ha:'',
                                forest_ha:'',
                                aparts_ha:'',
                                pasture_ha:'',
                                cvo:'',
                                system_id:'',
                                province_id:'',
                                canton_id:'',
                                district_id:'',
                                user_id:localStorage.getItem('userID'),
                            }
                        
                            this.$swal({
                                title: 'Registro de finca',
                                text: 'Se insertó finca de manera satisfactoria',
                                type: 'success',
                                icon:'success',
                                showCancelButton: false,
                                confirmButtonColor:'#5E8F23',
                                showCloseButton: true,
                                showLoaderOnConfirm: false  
                            }).then(function(){
                                self.$router.replace({name:'advance-farm'});
                            });
                        }).catch(error => {
                            console.log(error)
                        });
                    }
                }
            });
            
        },

        getLocation(){
            let self=this;
            navigator.geolocation.getCurrentPosition(
                position => {
                    console.log(self.center);
                    console.log(position.coords.latitude);
                    console.log(position.coords.longitude);
                    
                    self.center=[position.coords.latitude,position.coords.longitude];
                    self.positionxy=[position.coords.latitude,position.coords.longitude];
                },
                error => {
                console.log(error.message);
                },
            )   
        },

        modalShownMap(){
            setTimeout(() => {
                //mapObject is a property that is part of leaflet
                this.$refs.mymap.mapObject.invalidateSize(); 
            }, 100);
        },

        updateCords(latLng){
            //this.center = (event.latLng.lat(),event.latLng.lng());
            console.timeLog(latLng);
        }

    },
    watch:{
        'positionxy':function(value){
            console.log(value);
        },
        'farm.province_id': function(value){
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            console.log(value);
            fetch(this.$apiUrl+"list/cantons?province_id="+value,config)
            .then(response => response.json())
            .then(result => {
                console.log(result.cantons);
                this.cantonOptions = result.cantons.map(item => {return {value:item.id,text:item.name}})
            })

        },
        'farm.canton_id':function(value){
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            console.log(value);
            fetch(this.$apiUrl+"list/districts?canton_id="+value,config)
            .then(response => response.json())
            .then(result => {
                console.log(result.districts);
                this.districtOptions = result.districts.map(item => {return {value:item.id,text:item.name}})
            })
        },
    },
   /*  mounted() {
        const map = this.$parent.$parent.$refs.map.mapObject;
    }, */
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchProductSystem(config);
        this.fetchProvinces(config);
        this.fetchCantons(config);
        this.fetchDistricts(config);
        this.getLocation();
    }
}
</script>
    

<style lang="scss" scoped>
.dataUploadTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    color: #5E5873;
}



@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>